import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Award, Heart, Star, Users } from 'lucide-react';
const staff = [{
  name: 'Master Sarah Kim',
  title: 'Head Instructor & Owner',
  rank: '5th Degree Black Belt',
  experience: '20+ years',
  specialties: ['Youth Development', 'Leadership Training', 'Forms'],
  bio: 'Master Kim founded Limitless Taekwondo with a vision to create a welcoming, family-focused martial arts school. Her teaching philosophy emphasizes building confidence and character alongside technical skills.',
  image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=sarah&gender=female'
}, {
  name: 'Master Jennifer Lee',
  title: 'Senior Instructor',
  rank: '4th Degree Black Belt',
  experience: '15+ years',
  specialties: ['Self-Defense', 'Sparring', 'Adult Programs'],
  bio: 'Master Lee brings a dynamic teaching style that makes every class engaging and challenging. She specializes in helping adult students achieve their fitness and self-defense goals.',
  image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=jennifer&gender=female'
}, {
  name: 'Instructor Michelle Park',
  title: 'Little Dragons Specialist',
  rank: '3rd Degree Black Belt',
  experience: '10+ years',
  specialties: ['Early Childhood Education', 'Little Dragons', 'Family Classes'],
  bio: 'Instructor Park has a gift for working with young children. Her patience and creativity make learning fun for our youngest students while building essential skills.',
  image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=michelle&gender=female'
}, {
  name: 'Instructor David Chen',
  title: 'Assistant Instructor',
  rank: '2nd Degree Black Belt',
  experience: '8+ years',
  specialties: ['Competition Training', 'Board Breaking', 'Teen Programs'],
  bio: 'Instructor Chen is passionate about helping students reach their competitive potential. He brings energy and technical precision to every class he teaches.',
  image: 'https://api.dicebear.com/7.x/avataaars/svg?seed=david&gender=male'
}];
const values = [{
  icon: Heart,
  title: 'Student-Centered',
  description: 'Every student receives personalized attention and encouragement to reach their full potential.'
}, {
  icon: Star,
  title: 'Excellence',
  description: 'Our instructors maintain the highest standards of technical skill and teaching ability.'
}, {
  icon: Users,
  title: 'Community',
  description: 'We foster a supportive environment where students and families grow together.'
}, {
  icon: Award,
  title: 'Certified',
  description: 'All instructors are certified through Kukkiwon (World Taekwondo Headquarters).'
}];
export function StaffPage() {
  return <main className="pt-20 pb-20 bg-gray-50" data-id="element-532">
      <div className="bg-primary text-white py-16 mb-12" data-id="element-533">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-534">
          <Users className="w-16 h-16 mx-auto mb-6 text-gold" data-id="element-535" />
          <h1 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-536">Meet Our Team</h1>
          <p className="text-xl text-blue-100 max-w-2xl mx-auto" data-id="element-537">
            Our experienced, certified instructors are dedicated to helping you
            achieve your martial arts goals.
          </p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-538">
        {/* Values */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-16" data-id="element-539">
          {values.map(value => <Card key={value.title} className="p-6 text-center" data-id="element-540">
              <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-541">
                <value.icon className="w-6 h-6 text-primary" data-id="element-542" />
              </div>
              <h3 className="font-bold text-gray-900 mb-2" data-id="element-543">{value.title}</h3>
              <p className="text-sm text-gray-600" data-id="element-544">{value.description}</p>
            </Card>)}
        </div>

        {/* Staff Profiles */}
        <div className="space-y-8 mb-16" data-id="element-545">
          {staff.map((member, index) => <Card key={member.name} className="overflow-hidden" data-id="element-546">
              <div className={`grid grid-cols-1 md:grid-cols-3 gap-0 ${index % 2 === 1 ? 'md:grid-flow-dense' : ''}`} data-id="element-547">
                <div className={`p-8 md:p-12 flex flex-col justify-center ${index % 2 === 1 ? 'md:col-start-2 md:col-span-2' : 'md:col-span-2'}`} data-id="element-548">
                  <div className="flex items-start justify-between mb-4" data-id="element-549">
                    <div data-id="element-550">
                      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-1" data-id="element-551">
                        {member.name}
                      </h2>
                      <p className="text-primary font-semibold mb-2" data-id="element-552">
                        {member.title}
                      </p>
                    </div>
                    <div className="text-right" data-id="element-553">
                      <div className="bg-gold/10 text-gold px-3 py-1 rounded-full text-sm font-semibold mb-1" data-id="element-554">
                        {member.rank}
                      </div>
                      <p className="text-xs text-gray-500" data-id="element-555">
                        {member.experience}
                      </p>
                    </div>
                  </div>

                  <p className="text-gray-600 mb-6 leading-relaxed" data-id="element-556">
                    {member.bio}
                  </p>

                  <div data-id="element-557">
                    <h4 className="font-semibold text-gray-900 mb-3" data-id="element-558">
                      Specialties:
                    </h4>
                    <div className="flex flex-wrap gap-2" data-id="element-559">
                      {member.specialties.map(specialty => <span key={specialty} className="px-3 py-1 bg-blue-50 text-primary rounded-full text-sm font-medium" data-id="element-560">
                          {specialty}
                        </span>)}
                    </div>
                  </div>
                </div>

                <div className={`h-64 md:h-auto ${index % 2 === 1 ? 'md:col-start-1 md:row-start-1' : ''}`} data-id="element-561">
                  <div className="w-full h-full bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center p-8" data-id="element-562">
                    <img src={member.image} alt={member.name} className="w-48 h-48 rounded-full border-4 border-white shadow-lg" data-id="element-563" />
                  </div>
                </div>
              </div>
            </Card>)}
        </div>

        {/* Female Leadership Highlight */}
        <Card className="p-8 md:p-12 mb-12 bg-gradient-to-r from-primary/5 to-accent/5 border-2 border-primary/20" data-id="element-564">
          <div className="max-w-3xl mx-auto text-center" data-id="element-565">
            <div className="w-16 h-16 bg-primary/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-566">
              <Heart className="w-8 h-8 text-primary" data-id="element-567" />
            </div>
            <h2 className="text-3xl font-bold text-gray-900 mb-4" data-id="element-568">
              Female-Led Excellence
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-569">
              Limitless Taekwondo is proudly led by female instructors who bring
              a unique perspective to martial arts training. We balance
              discipline with nurturing support, creating an environment where
              every student—regardless of age or gender—can thrive and reach
              their full potential.
            </p>
          </div>
        </Card>

        {/* CTA */}
        <Card className="p-8 md:p-12 text-center bg-primary text-white" data-id="element-570">
          <h2 className="text-3xl font-bold mb-4" data-id="element-571">Train with the Best</h2>
          <p className="text-blue-100 mb-8 max-w-2xl mx-auto" data-id="element-572">
            Experience the difference that expert, caring instruction makes.
            Start your journey with our 4-week trial.
          </p>
          <Link to="/trial" data-id="element-573">
            <Button size="lg" className="bg-accent hover:bg-accent-dark text-white border-none" data-id="element-574">
              Start Your 4-Week Trial
            </Button>
          </Link>
        </Card>
      </div>
    </main>;
}